<template>
  <div class="min-h-screen flex flex-col max-w-full overflow-x-hidden bg-page">
    <!-- Using our new Header component -->
    <Header />

    <!-- Enhanced Main Content -->
    <main class="flex-1 max-w-full overflow-x-hidden bg-transparent transition-all duration-300" :class="isScrolled ? 'pt-14' : 'pt-16'">
      <slot />
    </main>

    <!-- Footer Component -->
    <Footer />

    <!-- WhatsApp Sticky Button -->
    <WhatsAppButton />
  </div>
</template>

<script setup>
import Header from '~/components/layout/Header.vue';
import Footer from '~/components/layout/Footer.vue';
import WhatsAppButton from '~/components/WhatsAppButton.vue';

const isScrolled = ref(false);

onMounted(() => {
  const handleScroll = () => {
    isScrolled.value = window.scrollY > 10;
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll();

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
  });
});
</script>

<style scoped>
/* Layout-specific styles only */
</style>
